import { render } from "./_icon-big-close.vue?vue&type=template&id=3b4b5b54"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__